import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { CountDownTimer } from "@website/ui/count-down-timer";
import { DigitalTextField } from "@website/ui/digital-text-field";
import { Loading } from "@website/ui/loading";
import { numberConvert } from "@website/utils/number-convert";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { useB2BOtp } from "@website/widget/login/components/b2b-otp/b2b-otp.hook";
import styles from "@website/widget/login/components/b2b-otp/b2b-otp.module.scss";
import { B2BOptPropertiesTypes } from "@website/widget/login/components/b2b-otp/b2b-otp.types";
import { FC, useCallback } from "react";

export const B2BOtp: FC<B2BOptPropertiesTypes> = (properties) => {
  const { userData } = properties;
  const {
    otp,
    onChangeOtp,
    onSubmitOtp,
    isLoading,
    error,
    showSendAgain,
    onClickSendAgain,
    isLoadingSendAgain,
    onTimerEnd,
    onBackClick
  } = useB2BOtp(properties);

  const remainedTime = useCallback(() => {
    const now = Date.now();
    try {
      if (userData?.otpValidUntil) {
        return Math.floor(userData?.otpValidUntil - now / 1000) || 120;
      }
      return 120;
    } catch {
      return 120;
    }
  }, [userData?.otpValidUntil]);

  return (
    <div className={styles["container"]}>
      <div className={styles["title"]}>
        {`کد دریافت شده به شماره ${numberConvert(userData?.phoneNumber, {
          locale: "fa"
        })} را وارد کنید.`}
      </div>
      <div className="text-caption py-1">
        کد در پیام رسان «بله» نیز برایتان ارسال شده است.
      </div>
      <div className={styles["sub-title"]}>
        شماره موبایل اشتباه است؟
        <Button
          color="secondary"
          onClick={onBackClick}
          size="small"
          type="button"
          variant="text"
        >
          ویرایش
        </Button>
      </div>
      <form onSubmit={isLoading ? undefined : onSubmitOtp}>
        <div className={styles["input"]}>
          <DigitalTextField
            className="text-center"
            error={Boolean(error)}
            helperText={error}
            num={userData?.otpLength || 5}
            onChange={onChangeOtp}
            value={otp}
          />
        </div>
        <div className={styles["info"]}>
          {showSendAgain ? (
            <>
              {"کد تایید را دریافت نکرده اید؟ "}
              <Button
                color="secondary"
                onClick={isLoadingSendAgain ? undefined : onClickSendAgain}
                size="small"
                type="button"
                variant="text"
              >
                {isLoadingSendAgain ? (
                  <Loading color="secondary" size="sm" />
                ) : (
                  "ارسال دوباره"
                )}
              </Button>
            </>
          ) : (
            <>
              {"ارسال دوباره کد تایید تا "}&nbsp;
              <CountDownTimer
                onTimerEnd={onTimerEnd}
                seconds={remainedTime()}
              />
            </>
          )}
        </div>
        <div className={styles["footer"]}>
          <Button
            color="secondary"
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            {isLoading ? (
              <Loading color="white" size="lg" />
            ) : userData?.userExists ? (
              replaceSnappTripBasedOnChannel("تایید و ورود به اسنپ‌تریپ!")
            ) : (
              "تایید و ادامه"
            )}
          </Button>
          <Button
            StartIcon={<MaterialIcon name="support_agent" />}
            color="secondary"
            fullWidth
            size="large"
            type="button"
            variant="text"
          >
            تماس با پشتیبانی (۱۲۳ ۰۰۰ ۹۲ ۰۲۱)
          </Button>
        </div>
      </form>
    </div>
  );
};
